import { WildfireRegion } from 'features/wildfires/wildfireGeoEventData.types';
import { NotificationSettingTypes } from '../../constants';

export type NotificationSettingsKeys = keyof typeof NotificationSettingTypes;

export type NotificationOption =
  (typeof NotificationSettingTypes)[NotificationSettingsKeys];

export type NotificationRegion = {
  id: number;
  displayName: string;
  state: string;
  stateDisplayName: string;
  isReporterCoveredForFire: boolean;
};

export type NotificationSetting = {
  region: NotificationRegion;
  setting: NotificationOption;
};

export type NotificationSettingForPut = {
  region: NotificationRegion | WildfireRegion;
  setting: NotificationOption;
};

export type NotificationSettingAPI = {
  data: NotificationSetting[];
};

export type RegionSection = {
  title: string;
  regionSettings: NotificationSetting[];
  isReporterCoveredForFire: boolean;
};

export enum NotificationType {
  Normal = 'normal',
  Silent = 'silent',
}
